import { useNavigate } from "react-router"
import { useTranslation } from "react-i18next"
import { AUTH_CODE_TYPE_ENUM } from "@antipartido-inc/contracts-ifaces"
import { VerificationCodeForm } from "../../../modules/VerificationCodeForm"
import { consumeLoginReturnTo } from "../../../../utils/loginReturnTo"
import { DomainError } from "../../../../domain/_kernel/DomainError"

interface VerificationStepProps {
  email: string
  onBack: () => void
}

export function VerificationStep({ email, onBack }: VerificationStepProps) {
  const navigate = useNavigate()
  const { t } = useTranslation("auth")

  const handleSubmit = (email: string, authCode: string): Promise<void> => {
    return window.domain.SignInAuthUseCase.execute({
      email,
      authCode,
    })
      .then(() => {
        navigate(consumeLoginReturnTo(), { viewTransition: true })
      })
      .catch((err: unknown) => {
        const errorCode = err instanceof DomainError ? err.code : "unknown"
        const errorMessage = t(`errors.${errorCode}`, { defaultValue: t("errors.unknown") }) as string
        throw new Error(errorMessage)
      })
  }

  const handleResend = async () => {
    await window.domain.SendAuthCodeAuthUseCase.execute({
      email,
      type: AUTH_CODE_TYPE_ENUM.LOGIN,
    }).catch((err: unknown) => {
      const errorCode = err instanceof DomainError ? err.code : "unknown"
      const errorMessage = t(`errors.${errorCode}`, { defaultValue: t("errors.unknown") }) as string
      throw new Error(errorMessage)
    })
  }

  const literals = {
    ...t("shared.verify", { returnObjects: true, email }),
    button: t("login.verify.button"),
    infoMessage: t("login.verify.infoMessage"),
    resendSuccess: t("login.verify.resendSuccess"),
  }

  return (
    <VerificationCodeForm
      email={email}
      literals={literals}
      onSubmit={handleSubmit}
      onResend={handleResend}
      onBack={onBack}
    />
  )
}
